module.exports = __webpack_public_path__ + "img/slider-home-2@3x.8bf61524.png";